import { dataset } from "@/data";
import { scoreAgent } from "@/engine/scoring";
import type { AgentScore } from "@/types";

// Precompute every agent's score once. Deterministic: same data -> same output.
export const agentScores: Map<string, AgentScore> = new Map(
  dataset.agents.map((a) => [a.id, scoreAgent(a, dataset.scoring)])
);

export function getScore(agentId: string): AgentScore | undefined {
  return agentScores.get(agentId);
}
